// extracted by mini-css-extract-plugin
export var closeButton = "_is-1";
export var closeX = "_is-3";
export var container = "_is-0";
export var image = "_is-2";